import logoClari from '@/assets/logo-clari.svg'
import Icon from '@/components/Iconography'
import { Icon as Icon2 } from '@conexasaude/iconography/icons'
import { Text } from '@conexasaude/conexa-hero'
import { Fragment, FunctionComponent, PropsWithChildren, useState } from 'react'
import { RenderIf } from '../RenderIf'
import ClariPage from './pages/clariPage'
import { useStyles } from './styles'
import { SerializedStyles } from '@emotion/utils'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'

interface ClariHelperProps {
  params?: { key: string; value: string }[]
  showShotcut?: boolean
  supportTextButton?: string
  callback?: () => void
  cssLink?: SerializedStyles
}

const ClariHelper: FunctionComponent<ClariHelperProps> = ({
  params,
  showShotcut = true,
  supportTextButton,
  callback,
  cssLink,
}: PropsWithChildren<ClariHelperProps>) => {
  const [clariChatMaximized, setClariChatMaximized] = useState(false)
  const [openClariChat, setOpenClariChat] = useState<boolean>(false)
  const styles = useStyles()
  const { isClariEnabled } = useAuthContext()
  const { clinic } = useAuthContext()

  if (clinic && !isClariEnabled) {
    return null
  }

  return (
    <Fragment>
      <RenderIf condition={!openClariChat && showShotcut}>
        <button
          css={styles.clariHelp}
          onClick={() => {
            setOpenClariChat(true)
            callback?.()
          }}
        >
          <Text>{supportTextButton || 'Precisa de ajuda?'}</Text>
          <Icon name="clari-logo" />
        </button>
      </RenderIf>
      <RenderIf condition={!openClariChat && !showShotcut}>
        <Text
          renderAs="span"
          css={cssLink ?? styles.supportLink}
          variant="linkUnderline"
          onClick={() => {
            callback?.()
            setOpenClariChat(true)
          }}
        >
          {supportTextButton || 'Precisa de ajuda?'}
        </Text>
      </RenderIf>
      <RenderIf condition={openClariChat}>
        <div css={styles.clariContainer} data-fullscreen={clariChatMaximized}>
          <div css={styles.clariHeader} data-fullscreen={clariChatMaximized}>
            <img src={logoClari} alt="Clari Logo" />
            <div css={styles.clariHeaderRightSide}>
              <button>
                <Icon2
                  name={
                    clariChatMaximized !== true
                      ? 'fullscreen'
                      : 'minimize-screen'
                  }
                  color="white"
                  size={20}
                  onClick={() =>
                    setClariChatMaximized(clariChatMaximized !== true)
                  }
                />
              </button>
              <button>
                <Icon
                  name="clari-close"
                  onClick={() => {
                    setOpenClariChat(false)
                    setClariChatMaximized(false)
                  }}
                />
              </button>
            </div>
          </div>
          <ClariPage
            style={
              clariChatMaximized ? styles.clariPageMaximized : styles.clariPage
            }
            params={params}
          ></ClariPage>
        </div>
      </RenderIf>
    </Fragment>
  )
}

export default ClariHelper
